/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import FormData from "form-data";

/**
 * Checks whether a value is neither null nor undefined.
 *
 * @param value - The value to check
 * @returns True when value is defined
 */
export const isDefined = <T>(
  value: T | null | undefined
): value is Exclude<T, null | undefined> => {
  return value !== undefined && value !== null;
};

/**
 * isString function.
 *
 * @param {*} value - Parameter description
 *
 * @returns {*} Return value description
 */
export const isString = (value: any): value is string => {
  return typeof value === "string";
};

/**
 * isStringWithValue function.
 *
 * @param {*} value - Parameter description
 *
 * @returns {*} Return value description
 */
export const isStringWithValue = (value: any): value is string => {
  return isString(value) && value !== "";
};

// Helper function to check if value has blob-like structure
/**
 * hasBlobStructure function.
 *
 * @param {*} value - Parameter description
 *
 * @returns {*} Return value description
 */
function hasBlobStructure(value: any): boolean {
  return typeof value === "object" &&
         typeof value.type === "string" &&
         typeof value.stream === "function" &&
         typeof value.arrayBuffer === "function";
}

// Helper function to check if value has blob-like constructor
/**
 * hasBlobConstructor function.
 *
 * @param {*} value - Parameter description
 *
 * @returns {*} Return value description
 */
function hasBlobConstructor(value: any): boolean {
  return typeof value.constructor === "function" &&
         typeof value.constructor.name === "string" &&
         /^(Blob|File)$/.test(value.constructor.name) &&
         /^(Blob|File)$/.test(value[Symbol.toStringTag]);
}

/**
 * isBlob function.
 *
 * @param {*} value - Parameter description
 *
 * @returns {*} Return value description
 */
export const isBlob = (value: any): value is Blob => {
  return hasBlobStructure(value) && hasBlobConstructor(value);
};

/**
 * isFormData function.
 *
 * @param {*} value - Parameter description
 *
 * @returns {*} Return value description
 */
export const isFormData = (value: any): value is FormData => {
  return value instanceof FormData;
};

/**
 * isSuccess function.
 *
 * @param {*} status - Parameter description
 *
 * @returns {*} Return value description
 */
export const isSuccess = (status: number): boolean => {
  return status >= 200 && status < 300;
};

/**
 * base64 function.
 *
 * @param {*} str - Parameter description
 *
 * @returns {*} Return value description
 */
export const base64 = (str: string): string => {
  try {
    return btoa(str);
  } catch (err) {
    // @ts-ignore
    return Buffer.from(str).toString("base64");
  }
};
